<template>
  <v-layout row wrap justify-end>
    <v-btn small outline color="blue-grey" class="export-btn"><v-icon small left>picture_as_pdf</v-icon>PDF</v-btn>
    <v-btn small outline color="blue-grey" class="export-btn"><v-icon small left>grid_on</v-icon>Excel</v-btn>
    <v-btn small dark color="blue-grey darken-4" class="export-btn"><v-icon small left>archive</v-icon>Export ZIP</v-btn>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },
};
</script>

<style scoped src="./Styles/SuperSyndicate.css"></style>
